import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Col, Row, Modal } from "react-bootstrap";
import { BsCheckCircle } from "react-icons/bs";
import { Spinner } from "react-bootstrap";

import { getRequest, postRequest } from "../../api/axiosRequests";
import CustomSelectWithSearch from "../../common/components/SelectWithSearch";

export default function WorkoutExerciseForm({
  idSuperserie,
  getCurrentWorkoutExercise,
  onHide,
  getPos,
  show,
  onSubmit,
}) {
  const [exercises, setExercises] = useState([]);
  const [filteredExercises, setFilteredExercises] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [workoutExercise, setWorkoutExercise] = useState({ id: -1 });
  const [acceleration, setAcceleration] = useState(0);
  const [power, setPower] = useState(0);
  const [selectedExercise, setSelectedExercise] = useState("");
  const [repetitions, setRepetitions] = useState(0);
  const [rest, setRest] = useState(0);
  const [weight, setWeight] = useState(0);
  const [weightMaximumPercentage, setWeightMaximumPercentage] = useState(0);
  const [duration, setDuration] = useState(0);
  const [centimeters, setCentimeters] = useState(0);
  const [both_sides, setBothSides] = useState(false);
  const [position, setPosition] = useState(0);
  const [isNew, setIsNew] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const initForm = (workoutExerciseData) => {
    if (workoutExerciseData.id == -1) {
      setAcceleration(0);
      setPower(0);
      setRepetitions(0);
      setRest(0);
      setWeight(0);
      setWeightMaximumPercentage(0);
      setDuration(0);
      setCentimeters(0);
      setBothSides(false);
      setPosition(workoutExerciseData.position);
      fetchExercises();
      setIsNew(true);
    } else {
      setAcceleration(workoutExerciseData.acceleration);
      setPower(workoutExerciseData.power);
      setRepetitions(workoutExerciseData.repetitions);
      setRest(workoutExerciseData.rest);
      setWeight(workoutExerciseData.weight);
      setWeightMaximumPercentage(workoutExerciseData.weightMaximumPercentage);
      setDuration(workoutExerciseData.duration);
      setSelectedExercise(workoutExerciseData.exercise);
      setCentimeters(workoutExerciseData.centimeters);
      setBothSides(workoutExerciseData.both_sides);
      setPosition(workoutExerciseData.position);
      setIsNew(false);
    }
  };

  const retrieveWorkoutExercise = () => {
    const data = getCurrentWorkoutExercise();
    if (data.id === -1) {
      data.position = getPos();
    }
    setWorkoutExercise(data);
    initForm(data);
  };

  async function fetchExercises() {
    try {
      const headers = { Authorization: localStorage.getItem("jwt") };
      const response = await getRequest("exerciseList/", headers);
      const exerciseList = response["data"];
      setExercises(exerciseList);
      setFilteredExercises(exerciseList);
      const currentExercise = exerciseList.filter(
        (e) => e.id == workoutExercise.exercise
      );
      if (currentExercise && currentExercise.length > 0) {
        setSelectedExercise(currentExercise[0].id);
      } else {
        setSelectedExercise(exerciseList[0].id);
      }
    } catch (err) { }
  }

  useEffect(() => {
    initForm(workoutExercise);
  }, []);

  useEffect(() => {
    if (exercises.length > 0) {
      const filtered = exercises.filter((exercise) =>
        exercise.name.toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredExercises(filtered);
    }
  }, [filterText, exercises]);

  async function workoutPostRequest(data) {
    const csrftoken = Cookies.get("csrftoken");
    const headers = {
      Authorization: localStorage.getItem("jwt"),
      "Content-Type": "multipart/form-data",
      "X-CSRFToken": csrftoken,
    };
    const response = await postRequest("workoutExercise/", data, headers);
    return response;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    let formData = new FormData();
    const id = workoutExercise.id ? workoutExercise.id : "-1";
    formData.append("id", id);
    formData.append("exercise", selectedExercise);
    formData.append("superserie", idSuperserie);
    formData.append("repetitions", repetitions);
    formData.append("duration", duration);
    formData.append("rest", rest);
    formData.append("weight", weight);
    formData.append("weightMaximumPercentage", weightMaximumPercentage);
    formData.append("power", power);
    formData.append("acceleration", acceleration);
    formData.append("centimeters", centimeters);
    formData.append("both_sides", both_sides);
    formData.append("position", position);
    workoutPostRequest(formData).then((result) => {
      onSubmit();
      setLoaded(true);
      setIsLoading(false);
      event.target.submit();
    });
  };

  const updateExercise = (event) => {
    setSelectedExercise(event.target.value);
  };

  const handleFilterChange = (event) => {
    setFilterText(event.target.value);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      onShow={retrieveWorkoutExercise}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {isNew && "New workout exercise"}
          {!isNew && "Update workout exercise"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          className="p-2"
          onSubmit={handleSubmit}
          action="/private/adminProtocols"
        >
          <div
            style={{
              maxHeight: "300px",
              width: "100%",
              maxWidth: "100%",
              overflowY: "scroll",
              overflowX: "hidden",
            }}
          >
            <div className="m-3">
              <Row>
                <Col xs={8}>
                  <Form.Group className="mb-3">
                    <Form.Label>Exercise</Form.Label>
                    <CustomSelectWithSearch
                      options={exercises}
                      value={selectedExercise}
                      onChange={updateExercise}
                      onFilter={handleFilterChange}
                      filterText={filterText}
                      width={350}
                    />
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Both sides</Form.Label>
                    <Form.Check
                      type="switch"
                      checked={both_sides}
                      onChange={(event) => {
                        setBothSides(event.target.checked);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Repetitions</Form.Label>
                    <Form.Control
                      type="number"
                      autoComplete="repetitions"
                      value={repetitions}
                      onChange={(event) => {
                        setRepetitions(event.target.value);
                      }}
                      style={{ border: "2px solid #f2f2f2" }}
                      placeholder=""
                      required
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Duration (s)</Form.Label>
                    <Form.Control
                      type="number"
                      autoComplete="duration"
                      value={duration}
                      onChange={(event) => {
                        setDuration(event.target.value);
                      }}
                      style={{ border: "2px solid #f2f2f2" }}
                      placeholder=""
                      required
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Rest (s)</Form.Label>
                    <Form.Control
                      type="number"
                      autoComplete="rest"
                      value={rest}
                      onChange={(event) => {
                        setRest(event.target.value);
                      }}
                      style={{ border: "2px solid #f2f2f2" }}
                      placeholder=""
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Weight</Form.Label>
                    <Form.Control
                      type="number"
                      autoComplete="weight"
                      value={weight}
                      onChange={(event) => {
                        setWeight(event.target.value);
                      }}
                      style={{ border: "2px solid #f2f2f2" }}
                      placeholder=""
                      required
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Weight (%)</Form.Label>
                    <Form.Control
                      type="number"
                      autoComplete="weightMaximumPercentage"
                      value={weightMaximumPercentage}
                      onChange={(event) => {
                        setWeightMaximumPercentage(event.target.value);
                      }}
                      style={{ border: "2px solid #f2f2f2" }}
                      placeholder=""
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Acceleration</Form.Label>
                    <Form.Control
                      type="number"
                      autoComplete="acceleration"
                      value={acceleration}
                      onChange={(event) => {
                        setAcceleration(event.target.value);
                      }}
                      style={{ border: "2px solid #f2f2f2" }}
                      placeholder=""
                      required
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Power</Form.Label>
                    <Form.Control
                      type="number"
                      autoComplete="power"
                      value={power}
                      onChange={(event) => {
                        setPower(event.target.value);
                      }}
                      style={{ border: "2px solid #f2f2f2" }}
                      placeholder=""
                      required
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Centimeters</Form.Label>
                    <Form.Control
                      type="number"
                      autoComplete="centimeters"
                      value={centimeters}
                      onChange={(event) => {
                        setCentimeters(event.target.value);
                      }}
                      style={{ border: "2px solid #f2f2f2" }}
                      placeholder=""
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </div>
          <br />
          <Button
            style={{ width: "100%" }}
            variant="dark"
            type="submit"
            disabled={isLoading || loaded}
          >
            {isLoading && <Spinner animation="border" />}
            {!isLoading && !loaded && "Save"}
            {!isLoading && loaded && <BsCheckCircle size={30} />}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}